<script setup>
import Select from "primevue/select";
import { trans } from 'laravel-vue-i18n';

const icons = [
  {
    label: trans('icons.group_brands'),
    items: [
      { label: 'Amazon', value: 'pi pi-amazon', group: 'brands' },
      { label: 'Apple', value: 'pi pi-apple', group: 'brands' },
      { label: 'Microsoft', value: 'pi pi-microsoft', group: 'brands' },
      { label: 'Google', value: 'pi pi-google', group: 'brands' },
      { label: 'Android', value: 'pi pi-android', group: 'brands' }
    ]
  },
  {
    label: trans('icons.group_transport'),
    items: [
      { label: trans('icons.car'), value: 'pi pi-car', group: 'transport' },
      { label: trans('icons.truck'), value: 'pi pi-truck', group: 'transport' }
    ]
  },
  {
    label: trans('icons.group_payments'),
    items: [
      { label: trans('icons.payment'), value: 'pi pi-money-bill', group: 'payments' },
      { label: trans('icons.wallet'), value: 'pi pi-wallet', group: 'payments' },
      { label: 'Paypal', value: 'pi pi-paypal', group: 'payments' },
      { label: 'Bitcoin', value: 'pi pi-bitcoin', group: 'payments' },
      { label: trans('icons.credit_card'), value: 'pi pi-credit-card', group: 'payments' }
    ]
  },
  {
    label: trans('icons.group_communication'),
    items: [
      { label: trans('icons.phone'), value: 'pi pi-phone', group: 'communication' },
      { label: trans('icons.envelope'), value: 'pi pi-envelope', group: 'communication' },
      { label: trans('icons.comment'), value: 'pi pi-comment', group: 'communication' },
      { label: trans('icons.chat'), value: 'pi pi-comments', group: 'communication' },
      { label: trans('icons.address_book'), value: 'pi pi-address-book', group: 'communication' }
    ]
  },
  {
    label: trans('icons.group_time'),
    items: [
      { label: trans('icons.stopwatch'), value: 'pi pi-stopwatch', group: 'time' },
      { label: trans('icons.hourglass'), value: 'pi pi-hourglass', group: 'time' },
      { label: trans('icons.clock'), value: 'pi pi-clock', group: 'time' },
      { label: trans('icons.calendar'), value: 'pi pi-calendar', group: 'time' },
      { label: trans('icons.schedule'), value: 'pi pi-calendar-plus', group: 'time' }
    ]
  },
  {
    label: trans('icons.group_navigation'),
    items: [
      { label: trans('icons.arrow_down'), value: 'pi pi-arrow-down', group: 'navigation' },
      { label: trans('icons.arrow_up'), value: 'pi pi-arrow-up', group: 'navigation' },
      { label: trans('icons.arrow_left'), value: 'pi pi-arrow-left', group: 'navigation' },
      { label: trans('icons.arrow_right'), value: 'pi pi-arrow-right', group: 'navigation' },
      { label: trans('icons.arrow_down_left'), value: 'pi pi-arrow-down-left', group: 'navigation' },
      { label: trans('icons.arrow_down_right'), value: 'pi pi-arrow-down-right', group: 'navigation' },
      { label: trans('icons.arrow_up_left'), value: 'pi pi-arrow-up-left', group: 'navigation' },
      { label: trans('icons.arrow_up_right'), value: 'pi pi-arrow-up-right', group: 'navigation' },
      { label: trans('icons.double_arrow_down'), value: 'pi pi-angle-double-down', group: 'navigation' },
      { label: trans('icons.double_arrow_up'), value: 'pi pi-angle-double-up', group: 'navigation' },
      { label: trans('icons.double_arrow_left'), value: 'pi pi-angle-double-left', group: 'navigation' },
      { label: trans('icons.double_arrow_right'), value: 'pi pi-angle-double-right', group: 'navigation' },
      { label: trans('icons.angle_down'), value: 'pi pi-angle-down', group: 'navigation' },
      { label: trans('icons.angle_up'), value: 'pi pi-angle-up', group: 'navigation' },
      { label: trans('icons.angle_left'), value: 'pi pi-angle-left', group: 'navigation' },
      { label: trans('icons.angle_right'), value: 'pi pi-angle-right', group: 'navigation' },
      { label: trans('icons.circle_arrow_down'), value: 'pi pi-arrow-circle-down', group: 'navigation' },
      { label: trans('icons.circle_arrow_up'), value: 'pi pi-arrow-circle-up', group: 'navigation' },
      { label: trans('icons.circle_arrow_left'), value: 'pi pi-arrow-circle-left', group: 'navigation' },
      { label: trans('icons.circle_arrow_right'), value: 'pi pi-arrow-circle-right', group: 'navigation' },
      { label: trans('icons.chevron_down'), value: 'pi pi-chevron-down', group: 'navigation' },
      { label: trans('icons.chevron_up'), value: 'pi pi-chevron-up', group: 'navigation' },
      { label: trans('icons.chevron_left'), value: 'pi pi-chevron-left', group: 'navigation' },
      { label: trans('icons.chevron_right'), value: 'pi pi-chevron-right', group: 'navigation' },
      { label: trans('icons.circle'), value: 'pi pi-circle', group: 'navigation' },
      { label: trans('icons.circle_fill'), value: 'pi pi-circle-fill', group: 'navigation' },
      { label: trans('icons.home'), value: 'pi pi-home', group: 'navigation' },
      { label: trans('icons.compass'), value: 'pi pi-compass', group: 'navigation' },
      { label: trans('icons.map'), value: 'pi pi-map', group: 'navigation' },
      { label: trans('icons.map_marker'), value: 'pi pi-map-marker', group: 'navigation' }
    ]
  },
  {
    label: trans('icons.group_social'),
    items: [
      { label: 'Facebook', value: 'pi pi-facebook', group: 'social' },
      { label: 'Instagram', value: 'pi pi-instagram', group: 'social' },
      { label: 'Twitter', value: 'pi pi-twitter', group: 'social' },
      { label: 'LinkedIn', value: 'pi pi-linkedin', group: 'social' },
      { label: 'Reddit', value: 'pi pi-reddit', group: 'social' },
      { label: 'Github', value: 'pi pi-github', group: 'social' },
      { label: 'Tiktok', value: 'pi pi-tiktok', group: 'social' },
      { label: 'Whatsapp', value: 'pi pi-whatsapp', group: 'social' },
      { label: 'Telegram', value: 'pi pi-telegram', group: 'social' },
      { label: 'Slack', value: 'pi pi-slack', group: 'social' },
      { label: 'Discord', value: 'pi pi-discord', group: 'social' },
      { label: 'Youtube', value: 'pi pi-youtube', group: 'social' },
      { label: 'Twitch', value: 'pi pi-twitch', group: 'social' },
      { label: 'Vimeo', value: 'pi pi-vimeo', group: 'social' }
    ]
  },
  {
    label: trans('icons.group_general'),
    items: [
      { label: trans('icons.user'), value: 'pi pi-user', group: 'general' },
      { label: trans('icons.users'), value: 'pi pi-users', group: 'general' },
      { label: trans('icons.user_edit'), value: 'pi pi-user-edit', group: 'general' },
      { label: trans('icons.user_add'), value: 'pi pi-user-plus', group: 'general' },
      { label: trans('icons.user_remove'), value: 'pi pi-user-minus', group: 'general' },
      { label: trans('icons.lock'), value: 'pi pi-lock', group: 'general' },
      { label: trans('icons.lock_open'), value: 'pi pi-unlock', group: 'general' },
      { label: trans('icons.settings'), value: 'pi pi-cog', group: 'general' },
      { label: trans('icons.heart'), value: 'pi pi-heart', group: 'general' },
      { label: trans('icons.heart_fill'), value: 'pi pi-heart-fill', group: 'general' },
      { label: trans('icons.star'), value: 'pi pi-star', group: 'general' },
      { label: trans('icons.star_fill'), value: 'pi pi-star-fill', group: 'general' },
      { label: trans('icons.clock'), value: 'pi pi-clock', group: 'general' },
      { label: trans('icons.eye'), value: 'pi pi-eye', group: 'general' },
      { label: trans('icons.eye_slash'), value: 'pi pi-eye-slash', group: 'general' },
      { label: trans('icons.bell'), value: 'pi pi-bell', group: 'general' },
      { label: trans('icons.calendar'), value: 'pi pi-calendar', group: 'general' },
      { label: trans('icons.list'), value: 'pi pi-list', group: 'general' },
      { label: trans('icons.list_check'), value: 'pi pi-list-check', group: 'general' },
      { label: trans('icons.book'), value: 'pi pi-book', group: 'general' },
      { label: trans('icons.image'), value: 'pi pi-image', group: 'general' },
      { label: trans('icons.images'), value: 'pi pi-images', group: 'general' },
      { label: trans('icons.address_book'), value: 'pi pi-address-book', group: 'general' },
      { label: trans('icons.tag'), value: 'pi pi-tag', group: 'general' },
      { label: trans('icons.tags'), value: 'pi pi-tags', group: 'general' },
      { label: trans('icons.gift'), value: 'pi pi-gift', group: 'general' },
      { label: trans('icons.wallet'), value: 'pi pi-wallet', group: 'general' }
    ]
  },
  {
    label: trans('icons.group_actions'),
    items: [
      { label: trans('icons.add'), value: 'pi pi-plus', group: 'actions' },
      { label: trans('icons.remove'), value: 'pi pi-minus', group: 'actions' },
      { label: trans('icons.edit'), value: 'pi pi-pencil', group: 'actions' },
      { label: trans('icons.save'), value: 'pi pi-save', group: 'actions' },
      { label: trans('icons.delete'), value: 'pi pi-trash', group: 'actions' },
      { label: trans('icons.print'), value: 'pi pi-print', group: 'actions' },
      { label: trans('icons.download'), value: 'pi pi-download', group: 'actions' },
      { label: trans('icons.upload'), value: 'pi pi-upload', group: 'actions' },
      { label: trans('icons.filter'), value: 'pi pi-filter', group: 'actions' },
      { label: trans('icons.search'), value: 'pi pi-search', group: 'actions' },
      { label: trans('icons.send'), value: 'pi pi-send', group: 'actions' },
      { label: trans('icons.undo'), value: 'pi pi-undo', group: 'actions' },
      { label: trans('icons.refresh'), value: 'pi pi-refresh', group: 'actions' },
      { label: trans('icons.play'), value: 'pi pi-play', group: 'actions' },
      { label: trans('icons.pause'), value: 'pi pi-pause', group: 'actions' },
      { label: trans('icons.stop_icon'), value: 'pi pi-stop', group: 'actions' }
    ]
  },
  {
    label: trans('icons.group_files'),
    items: [
      { label: trans('icons.file'), value: 'pi pi-file', group: 'files' },
      { label: trans('icons.file_pdf'), value: 'pi pi-file-pdf', group: 'files' },
      { label: trans('icons.file_excel'), value: 'pi pi-file-excel', group: 'files' },
    ]
  },
  {
    label: trans('icons.group_finance'),
    items: [
      { label: trans('icons.wallet'), value: 'pi pi-wallet', group: 'finance' },
      { label: trans('icons.credit_card'), value: 'pi pi-credit-card', group: 'finance' },
      { label: trans('icons.gift'), value: 'pi pi-gift', group: 'finance' }
    ]
  },
  {
    label: trans('icons.group_system'),
    items: [
      { label: trans('icons.settings'), value: 'pi pi-cog', group: 'system' },
      { label: trans('icons.notification'), value: 'pi pi-bell', group: 'system' },
      { label: trans('icons.lock'), value: 'pi pi-lock', group: 'system' },
      { label: trans('icons.lock_open'), value: 'pi pi-unlock', group: 'system' },
      { label: trans('icons.restart'), value: 'pi pi-refresh', group: 'system' },
      { label: trans('icons.power_off'), value: 'pi pi-power-off', group: 'system' }
    ]
  },
  {
    label: trans('icons.group_text'),
    items: [
      { label: trans('icons.bullets'), value: 'pi pi-list', group: 'text' },
      { label: trans('icons.align_left'), value: 'pi pi-align-left', group: 'text' },
      { label: trans('icons.align_center'), value: 'pi pi-align-center', group: 'text' },
      { label: trans('icons.align_right'), value: 'pi pi-align-right', group: 'text' },
      { label: trans('icons.align_justify'), value: 'pi pi-align-justify', group: 'text' },
    ]
  },
  {
    label: trans('icons.group_forms'),
    items: [
      { label: trans('icons.checkbox'), value: 'pi pi-check-square', group: 'forms' },
      { label: trans('icons.radio'), value: 'pi pi-circle-on', group: 'forms' },
      { label: trans('icons.password_field'), value: 'pi pi-key', group: 'forms' },
      { label: trans('icons.form_icon'), value: 'pi pi-id-card', group: 'forms' }
    ]
  },
  {
    label: trans('icons.group_media'),
    items: [
      { label: trans('icons.image'), value: 'pi pi-image', group: 'media' },
      { label: trans('icons.gallery'), value: 'pi pi-images', group: 'media' },
      { label: trans('icons.video'), value: 'pi pi-video', group: 'media' },
      { label: trans('icons.camera'), value: 'pi pi-camera', group: 'media' },
      { label: trans('icons.headphones'), value: 'pi pi-headphones', group: 'media' },
      { label: trans('icons.sound'), value: 'pi pi-volume-up', group: 'media' },
      { label: trans('icons.sound_off'), value: 'pi pi-volume-off', group: 'media' },
      { label: trans('icons.microphone'), value: 'pi pi-microphone', group: 'media' }
    ]
  },
  {
    label: trans('icons.group_users'),
    items: [
      { label: trans('icons.user'), value: 'pi pi-user', group: 'users' },
      { label: trans('icons.users'), value: 'pi pi-users', group: 'users' },
      { label: trans('icons.user_add'), value: 'pi pi-user-plus', group: 'users' },
      { label: trans('icons.user_remove'), value: 'pi pi-user-minus', group: 'users' },
      { label: trans('icons.user_edit'), value: 'pi pi-user-edit', group: 'users' }
    ]
  },
  {
    label: trans('icons.group_state'),
    items: [
      { label: trans('icons.state_ok'), value: 'pi pi-check', group: 'state' },
      { label: trans('icons.error'), value: 'pi pi-times', group: 'state' },
      { label: trans('icons.warning'), value: 'pi pi-exclamation-triangle', group: 'state' },
      { label: trans('icons.info'), value: 'pi pi-info-circle', group: 'state' },
      { label: trans('icons.question_mark'), value: 'pi pi-question-circle', group: 'state' },
      { label: trans('icons.cross'), value: 'pi pi-times-circle', group: 'state' },
      { label: trans('icons.check'), value: 'pi pi-check-circle', group: 'state' },
      { label: trans('icons.star'), value: 'pi pi-star', group: 'state' },
      { label: trans('icons.star_fill'), value: 'pi pi-star-fill', group: 'state' }
    ]
  },
  {
    label: trans('icons.group_security'),
    items: [
      { label: trans('icons.lock'), value: 'pi pi-lock', group: 'security' },
      { label: trans('icons.lock_open'), value: 'pi pi-unlock', group: 'security' },
      { label: trans('icons.key'), value: 'pi pi-key', group: 'security' },
      { label: trans('icons.shield'), value: 'pi pi-shield', group: 'security' }
    ]
  },
  {
    label: trans('icons.group_network'),
    items: [
      { label: trans('icons.globe'), value: 'pi pi-globe', group: 'network' },
      { label: 'Wi-Fi', value: 'pi pi-wifi', group: 'network' },
      { label: trans('icons.cloud'), value: 'pi pi-cloud', group: 'network' },
      { label: trans('icons.server'), value: 'pi pi-server', group: 'network' }
    ]
  },
  {
    label: trans('icons.group_tools'),
    items: [
      { label: trans('icons.settings'), value: 'pi pi-cog', group: 'tools' },
      { label: trans('icons.hammer'), value: 'pi pi-hammer', group: 'tools' },
      { label: trans('icons.briefcase'), value: 'pi pi-briefcase', group: 'tools' }
    ]
  },
  {
    label: trans('icons.group_other'),
    items: [
      { label: trans('icons.trash'), value: 'pi pi-trash', group: 'other' },
      { label: trans('icons.print'), value: 'pi pi-print', group: 'other' },
      { label: trans('icons.undo'), value: 'pi pi-undo', group: 'other' },
      { label: trans('icons.help'), value: 'pi pi-question', group: 'other' },
      { label: trans('icons.locked'), value: 'pi pi-lock', group: 'other' }
    ]
  }
];

const model = defineModel()
</script>

<template>
    <Select
        v-model="model"
        :options="icons"
        optionGroupLabel="label"
        optionGroupChildren="items"
        optionLabel="label"
        optionValue="value"
        filter
        variant="filled"
        fluid
        class="!h-[46px] !w-[78px]"
    >
        <template #option="{ option }">
            <i :class="option.value" class="mr-2" />
            {{ option.label }}
        </template>
        <template #value="{value}">
            <i class="flex h-full items-center" :class="value"></i>
        </template>
    </Select>
</template>

<style scoped lang="scss">
</style>
